import type {NavLinkProps} from '@github-ui/react-router'

import {NavLink} from '../../router'

interface NavLinkWithActiveClassNameProps extends Omit<NavLinkProps, 'className'> {
  className?: string
  isActive?: boolean
  ref?: React.Ref<HTMLAnchorElement>
}

export function NavLinkWithActiveClassName({
  ref,
  isActive: isActiveProps,
  className,
  ...restProps
}: NavLinkWithActiveClassNameProps) {
  return (
    <NavLink
      {...restProps}
      ref={ref}
      className={({isActive}) => {
        return isActive || isActiveProps ? `${className} selected`.trim() : className ?? ''
      }}
    />
  )
}

try{ NavLinkWithActiveClassName.displayName ||= 'NavLinkWithActiveClassName' } catch {}